import qs from "qs";

import ChatDepartmentsApi from "../../services/api/ChatDepartments";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import { getPath, removeEmptyVals } from "../../utils";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in chat departments actions:", err);
}

export const setChatDepartments = (payload) => {
  return {
    type: ActionTypes.SET_CHAT_DEPARTMENTS,
    payload,
  };
};

export const setCurrentPageChatDepartments = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_CHAT_DEPARTMENTS,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_CHAT_DEPARTMENT_FILTERS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_CHAT_DEPARTMENT,
    payload,
  };
};

export const setActiveChatDepartment = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_CHAT_DEPARTMENT,
    payload,
  };
};

export const getChatDepartments =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      //Todo: create new filter array with key value pairs
      let newFilters = [];
      const payload = removeEmptyVals({
        city_name: filters.cityName,
        department_name: filters.departmentName,
        issue_type_name: filters.issueTypeName,
        rank: filters.rank,
        enabled: filters.enabled,
        priority: filters.priority,
      });
      Object.keys(payload).map((key) => {
        newFilters.push({
          key: key,
          value:
            typeof payload[key] === "string"
              ? `'${payload[key]}'`
              : `${payload[key]}`,
        });
      });
      let finalPayload = {
        page_request: { page: 1, pageSize: 10, ...pageRequest },
        filters: newFilters,
      };
      dispatch(setLoader(true));
      let response = await ChatDepartmentsApi.getChatDepartments(finalPayload);
      dispatch(setLoader(false));
      if (response) {
        if (Object.keys(pageRequest).length > 0) {
          dispatch(
            setCurrentPageChatDepartments(getPath(pageRequest, "page", 1))
          );
        }
        dispatch(setChatDepartments(response));
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
        return response;
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getChatDepartmentById = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    console.log("id= ", id);
    let response = await ChatDepartmentsApi.getChatDepartmentById(id);
    dispatch(setLoader(false));
    if (response) {
      const departmentObj = getPath(response, "chat_department", {});
      dispatch(setActiveChatDepartment(departmentObj));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const upsertChatDepartment = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await ChatDepartmentsApi.upsertChatDepartment(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
